import React from 'react';
import styled from 'styled-components';

import Grid from './components/Grid';
import './styles/global.css';

const PageWrapper = styled.main`
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  width: fit-content;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-radius: 4px;
  text-align: center;
`;

const Title = styled.h1`
  font-family: 'Hack', 'Courier New', monospace;
  font-size: 2rem;
  margin: 0 0 0.5rem;
  font-weight: 100;
`;

function App() {
  return (
    <PageWrapper className="App">
      <Title>The Game</Title>
      <Grid gridSize={3} />
    </PageWrapper>
  );
}

export default App;
